import React from "react";

/*
 * This is here rather than as an svg in the /assets/images folder
 * so that it can fit the same api as all the  other icons as imported from
 * react icons.
 *
 * There were a few things i did to export this.
 *
 * I used svgr https://react-svgr.com/playground/?icon=true&replaceAttrValues=%23F44336%3DcurrentColor
 *
 * Such that i could replace the fill color with "currentColor"
 * This lets the icon take on the color of the currentText.
 *
 * Then i changed the height and width to equal 20px by 20px to match the size of
 * all the other icons so we can
 *
 *
 */
const SoguiLogoPink = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{"Normal"}</title>

      <path
        d="M15.8308 31.6615C7.10154 31.6615 0 24.56 0 15.8308C0 7.10155 7.10154 0 15.8308 0C24.56 0 31.6615 7.10155 31.6615 15.8308C31.6615 24.56 24.56 31.6615 15.8308 31.6615ZM15.8308 3.1877C8.85846 3.1877 3.18769 8.85847 3.18769 15.8308C3.18769 22.8031 8.85846 28.4739 15.8308 28.4739C22.8031 28.4739 28.4738 22.8031 28.4738 15.8308C28.4738 8.85847 22.8031 3.1877 15.8308 3.1877Z"
        fill="#F4406B"
      />
      <path
        d="M11.7537 13.5139C11.726 13.7046 11.6275 13.8769 11.4706 13.9877C11.3167 14.1046 11.126 14.16 10.9352 14.1323C10.7444 14.1046 10.5721 14.0154 10.4521 13.8585C9.99674 13.2585 9.5352 12.9477 9.09828 12.9477C8.46135 12.9662 7.86135 13.5939 7.68905 13.8308C7.55366 14.0215 7.3352 14.1385 7.09828 14.1385C6.94443 14.1385 6.79674 14.0923 6.67982 14.0031C6.51674 13.8954 6.4152 13.7292 6.37828 13.5385C6.34135 13.3477 6.38751 13.1477 6.4952 12.9939C6.54135 12.9292 7.55059 11.52 9.04905 11.4923C9.9752 11.4831 10.8398 11.9754 11.606 12.9662C11.7229 13.12 11.7783 13.3108 11.7506 13.5108L11.7537 13.5139Z"
        fill="#F4406B"
      />
      <path
        d="M25.2864 13.5046C25.2587 13.7046 25.1695 13.8769 25.0126 13.9877C24.8587 14.1139 24.6587 14.16 24.468 14.1323C24.2772 14.1046 24.1049 14.0154 23.9849 13.8585C23.5295 13.2585 23.0741 12.9477 22.6403 12.9477C21.9941 12.9662 21.4034 13.5939 21.231 13.8308C21.0957 14.0215 20.868 14.1385 20.631 14.1385C20.4864 14.1385 20.3387 14.0923 20.2126 14.0031C20.0587 13.8954 19.948 13.7292 19.9141 13.5385C19.8864 13.3477 19.9326 13.1477 20.0403 12.9939C20.0864 12.9292 21.0957 11.52 22.5972 11.4923C23.5172 11.4831 24.388 11.9754 25.1449 12.9662C25.2618 13.12 25.3172 13.3108 25.2895 13.5015L25.2864 13.5046Z"
        fill="#F4406B"
      />
      <path
        d="M17.4892 21.3139C17.4892 22.4616 16.7877 23.3908 15.9231 23.3908C15.0585 23.3908 14.3569 22.4616 14.3569 21.3139C14.3569 20.1662 15.0585 18.1108 15.9231 18.1108C16.7877 18.1108 17.4892 20.1662 17.4892 21.3139Z"
        fill="#F4406B"
      />
    </svg>
  );
};
export default SoguiLogoPink;
